import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CHECKOUT_URL } from '../utils/checkout';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-125" data-mp="1ei8nbq1m3lum">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-126" data-mp="1eg5p4iqb2met">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-127" data-mp="1ja0eo2sldvlt">PREZZO A TEMPO LIMITATO</p>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-128" data-mp="1n9r2bxmtnvm4">🏆 Offerta di Lancio</h2>
        <div className="relative mx-auto max-w-xl rounded-[2rem] border-2 border-brand-orange bg-brand-alt p-8 pt-10 shadow-xl md:p-12" data-id="element-129" data-mp="1s82be65am23a">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-brand-orange px-5 py-2 text-[10px] font-extrabold tracking-[0.14em] text-white" data-id="element-130" data-mp="227t7gc9i4p5h">
            MATEMATICA PRONTA
          </div>
          <div className="space-y-4 text-left" data-id="element-131" data-mp="7utktz6peuop">
            <PriceLine label="10 Volumi Completi (dalla 1ª primaria al biennio)" price="197 €" data-id="element-132" data-mp="7vmtx6t4xwa0" />
            <PriceLine label="5 Bonus Esclusivi" price="100 €" data-id="element-133" data-mp="1mihocz3og9wk" />
            <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-134" data-mp="1hodeo8311nrs">
              <span data-id="element-135" data-mp="1cr4trzqhv5mu">VALORE TOTALE</span>
              <span className="text-brand-purple line-through" data-id="element-136" data-mp="17s20tdnsgpv8">297 €</span>
            </div>
          </div>
          <div className="my-8 border-y border-brand-dark py-7" data-id="element-137" data-mp="25g2avziyywe0">
            <p className="text-xs font-extrabold tracking-[0.16em] text-brand-teal" data-id="element-138" data-mp="25d6fahulgjsq">SOLO OGGI</p>
            <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-blue md:text-7xl" data-id="element-139" data-mp="20emr0asj2vx7">
              19 € <span className="text-2xl" data-id="element-140" data-mp="1rfrj8u9u5drs">EUR</span>
            </p>
          </div>
          <CTAButton href={CHECKOUT_URL} className="w-full py-5 text-base md:text-lg" data-id="element-141" data-mp="1rhu7p9vcayue">
            PRENDI IL PACCHETTO MATEMATICA PRONTA
          </CTAButton>
          <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-142" data-mp="fzjc0fjgle9s">
            Pagamento unico · Download immediato · Accesso a vita
          </p>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between gap-4 border-b border-brand-dark pb-4 text-sm" data-id="element-143" data-mp="7k3n7cixk5q7">
      <span className="font-medium" data-id="element-144" data-mp="chvpn0h7ba8n">{label}</span>
      <span className="whitespace-nowrap font-bold text-brand-blue" data-id="element-145" data-mp="ckrocr0vi2y5">{price}</span>
    </div>;
}